
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg","data-token-name":"click"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.18 4.056A3.374 3.374 0 0110.703 6.6a.674.674 0 101.31-.324 4.721 4.721 0 00-4.919-3.568 4.804 4.804 0 00-4.378 4.35 4.72 4.72 0 003.468 4.917.675.675 0 00.823-.472.674.674 0 00-.473-.803 3.374 3.374 0 01-2.476-3.513 3.426 3.426 0 013.124-3.13z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6.817 13.458a6.072 6.072 0 01-5.465-6.212 6.144 6.144 0 015.896-5.894 6.072 6.072 0 016.213 5.463.677.677 0 00.994.529.675.675 0 00.349-.664A7.418 7.418 0 007.214.003a7.51 7.51 0 00-7.21 7.203 7.418 7.418 0 006.65 7.594.678.678 0 10.136-1.349l.027.007z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.823 14.163L13.3 11.641a.17.17 0 01-.048-.135.148.148 0 01.068-.122l1.592-1.099a.62.62 0 00-.162-1.1L7.66 7.069a.486.486 0 00-.479.115.472.472 0 00-.115.472l2.119 7.095a.634.634 0 00.499.432.628.628 0 00.6-.263l1.093-1.599a.149.149 0 01.121-.067.147.147 0 01.135.047l2.523 2.522a.621.621 0 00.877 0l.783-.789a.613.613 0 00.007-.87z","fill":"currentColor"}})])
          )
        }
      }
    